export default __webpack_public_path__ + "static/Pavimenti-78f01d8549d9b6f851218e90acc9e2db.jpg";